import React from 'react';

const EmptyCart = () => {
  return <div>Cart is empty</div>;
};

export default EmptyCart;
